type IndustryOption =
  | 'property-management'
  | 'higher-education'
  | 'senior-living'
  | 'employee-benefits'
  | 'other';

type LocationOption = 'california' | 'new-york' | 'texas' | 'florida' | 'other';

export interface IndustrySelectOption {
  value: IndustryOption;
  label: string;
}

export interface LocationSelectOption {
  value: LocationOption;
  label: string;
}

export const INDUSTRY_OPTIONS: ReadonlyArray<IndustrySelectOption> = [
  { value: 'property-management', label: 'Property Management' },
  { value: 'higher-education', label: 'Higher Education' },
  { value: 'senior-living', label: 'Senior Living' },
  { value: 'employee-benefits', label: 'Employee Benefits' },
  { value: 'other', label: 'Other' },
] as const;

export const LOCATION_OPTIONS: ReadonlyArray<LocationSelectOption> = [
  { value: 'california', label: 'California' },
  { value: 'new-york', label: 'New York' },
  { value: 'texas', label: 'Texas' },
  { value: 'florida', label: 'Florida' },
  { value: 'other', label: 'Other' },
] as const;

export interface PartnershipLeadFormData {
  name: string;
  email: string;
  phone: string;
  organization: string;
  industry: IndustryOption | '';
  location: LocationOption | '';
  message: string;
}

export const INITIAL_FORM_DATA: PartnershipLeadFormData = {
  name: '',
  email: '',
  phone: '',
  organization: '',
  industry: '',
  location: '',
  message: '',
};

// Note: Partnership leads are now handled via GraphQL directly to Clutter platform
// No longer using REST API endpoint
